/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListContactList } from '../../models/api-response-list-contact-list';

export interface ListContactList$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function listContactList(http: HttpClient, rootUrl: string, params: ListContactList$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListContactList>> {
  const rb = new RequestBuilder(rootUrl, listContactList.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListContactList>;
    })
  );
}

listContactList.PATH = '/v1/api/ui/contactList/list';
